<template>
  <div v-if="isReady" class="panel-body">
    <div class="text-size-20">
      セルモンへの出品を推奨する商品です。<br>
      ※出品には所定の審査を実施させていただきます。
    </div>
    <div class="fba-longterm-banner">
      <div class="fba-longterm-icon"></div>
      <fieldset>
        <legend>注目!</legend>
        <div class="fba-longterm-content">
          より多くの商品を出品することで、売上アップにつながります
        </div>
      </fieldset>
    </div>
    <div v-if="products.length > 0" class="fba-longterm-table">
      <premium-modal v-if="cantViewContent" />
      <div class="flexbox justify-right gap-10 no-wrap">
        <div v-if="!isEmptyObj(currentPlan)">
          残り出品可能数：<span>{{ remainingProduct }}</span>件
        </div>
        <button class="btn btn-primary btn-additional-of-list" @click="getAllPlans">出品数追加</button>
      </div>
      <div class="flexbox justify-between no-wrap gap-20">
        <div class="flexbox gap-10 no-wrap">
          <div>{{ products.length }} 件</div>
          <button class="btn btn-warning" :disabled="disableActions" type="button" @click="openModalConfirm()">
            選択した商品を出品する
            <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
          </button>
          <button class="btn btn-delete-product" :disabled="disableActions" type="button" @click="openModalConfirm(true)">
            選択した商品は通知しない
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </div>
        <span class="text-right">
          ※受取金額は、出品後に商品管理画面から変更することができます
        </span>
      </div>
      <table class="full-width bg-white mr-t-10">
        <thead>
          <tr>
            <th>
              <input type="checkbox" v-model="isCheckAll" @change="handleSelectAll">
            </th>
            <th class="product-info">商品情報</th>
            <th class="fee">受取金額(税込)</th>
            <th class="actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in products" :key="item.asin">
            <td>
              <input type="checkbox" v-model="selectedItems" :value="item.asin">
            </td>
            <td class="product-info">
              <div class="flexbox gap-10 no-wrap">
                <img v-if="item.image" :src="item.image" class="w-80" alt="">
                <div>
                  <div class="tooltip-wrapper">
                    <a
                      :href="'https://www.amazon.co.jp/gp/offer-listing/' + item.asin"
                      target="_blank"
                      class="text--underline product-name"
                      >
                      {{ sliceProductName(item.productName) }}
                    </a>
                    <span class="tooltip-text">{{ item.productName }}</span>
                  </div>
                  <div class="flexbox gap-20">
                    <div>
                      <span class="font-bold">SKU：</span>
                      <span class="">{{ item.sku }}</span>
                    </div>
                    <div>
                      <span class="font-bold">ASIN：</span>
                      <span class="">{{ item.asin }}</span>
                    </div>
                    <div>
                      <span class="font-bold">FNSKU：</span>
                      <span class="">{{ item.fnsku }}</span>
                    </div>
                  </div>
                  <div class="flexbox gap-20">
                    <span>
                      Amazon価格：
                      <b>¥{{ formatNumber(item.amazonPrice) }}</b>
                    </span>
                    <span>在庫数：<b>{{ formatNumber(item.numberOfStock) }}</b></span>
                  </div>
                </div>
              </div>
            </td>
            <td class="fee">
              <div class="flexbox justify-right gap-20">
                <div>
                  <span class="text-size-28"><b>¥{{ formatNumber(item.offerPrice) }}</b></span>
                </div>
              </div>
            </td>
            <td class="actions">
              <button class="btn btn-warning" type="button" @click="handleSellItem(item.asin)">
                出品する
              </button>
              <button class="btn btn-delete-product" type="button" @click="handleSellItem(item.asin, true)">
                通知しない
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal-confirm
      v-if="isShowConfirmModal"
      :message="confirmMessage"
      @confirm="handleSellItems"
      @close="closeModalConfirm"
    />
    <modal-add-listings
      v-if="openModalAddListings"
      :maxListingAmount="maxListingAmount"
      :remainingProduct="remainingProduct"
      :neededProductCount="neededProductCount"
      :listPlans="suggestPlans"
      @updatePlanStatus="updatePlanStatus"
      @close="handleCloseOverProductsModal"
    />
  </div>
</template>

<script>
import SalemonAgentService from '@/services/salemonagentservice'
import Util from '@/common/utility'
import ModalConfirm from '@/components/ModalConfirm'
import PremiumModal from './components/PremiumModalOverlay'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import PlanService from '@/services/planservice'
import ModalAddListings from '@/components/ModalAddListings'

export default {
  components: {
    ModalConfirm,
    PremiumModal,
    ModalAddListings
  },
  data () {
    return {
      isReady: false,
      isShowConfirmModal: false,
      isCheckAll: false,
      isDelete: false,
      selectedItems: [],
      loader: null,
      products: [],
      confirmMessage: '',
      confirmSellMessage: `
        <b>選択した商品をすべて出品しますが、よろしいですか？</b>
        <br>
        ※受取金額は、出品後に商品管理画面から変更することができます。
      `,
      confirmRemoveMessage: `
        <b>選択した商品は今後通知しませんが、よろしいですか？</b>
        <br>
        ※商品を通知しないとした場合
        <br>
        <ul>
          <li>次回以降セルモンエージェントでの通知対象外となります。</li>
          <li>今後も商品管理画面からは出品することができます。</li>
        </ul>
      `,
      currentPlan: {},
      remainingProduct: 0,
      suggestPlans: [],
      maxListingAmount: 0,
      neededProductCount: 0,
      openModalAddListings: false
    }
  },
  computed: {
    disableActions () {
      return this.selectedItems.length <= 0
    },
    setSelectdItems () {
      return new Set(this.selectedItems)
    },
    cantViewContent () {
      return this.$store.getters.getUser.memberPlan === '0' || this.$store.getters.getUser.isPremiumTrial
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.loader = this.$loading.show()
      await this.getProductAvailable()
      await this.getPlanStatus()
      this.isReady = true
      this.loader && this.loader.hide()
    },
    async getAllPlans () {
      this.loader = this.$loading.show()
      await PlanService.getAllPlans()
        .then(data => {
          this.suggestPlans = data.salmonPlan.avaiablePlans
          this.neededProductCount = 0
          this.openModalAddListings = true
        })
        .catch(err => {
          self.error = err
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async getPlanStatus () {
      let response = await PlanService.getPlanStatus()
      this.currentPlan = response.salmonPlan.currentPlan
      this.remainingProduct = response.salmonPlan.remainingProduct
    },
    async updatePlanStatus () {
      await PlanService.getPlanStatus()
        .then((response) => {
          this.currentPlan = response.salmonPlan.currentPlan
          this.remainingProduct = response.salmonPlan.remainingProduct
          this.$store.commit('toggleModal', {
            show: true,
            message: 'お支払いありがとうございます。<br/>商品数が追加されました。<br/>最大商品登録可能数が更新されました。'
          })
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    isEmptyObj (obj) {
      return Util.isEmptyObj(obj)
    },
    sliceProductName (productName) {
      const length = 80
      if (productName.length <= length) return productName

      return productName.slice(0, length / 2) + ' ... ' + productName.slice(-(length / 2))
    },
    async getProductAvailable () {
      await SalemonAgentService.getProductAvailable()
        .then((response) => {
          this.products = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
    },
    handleSelectAll () {
      if (this.isCheckAll) {
        this.selectedItems = this.products.map((i) => { return i.asin })
      } else {
        this.selectedItems = []
      }
    },
    async handleSellItem (asin, isDelete = false) {
      const logParams = {
        name: isDelete ? eventCode.salemon_agent.product_available.click_disable_notify_btn : eventCode.salemon_agent.product_available.click_regis_btn,
        properties: {
          asin: asin
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      const params = {
        products: this.products.filter(i => i.asin === asin),
        isDelete: isDelete
      }
      await SalemonAgentService.regisProducts(params)
        .then((response) => {
          if (response.data && response.data.suggestPlans && response.data.suggestPlans.length > 0) {
            this.openModalAddListings = true
            this.suggestPlans = response.data.suggestPlans
            this.maxListingAmount = response.data.maxListingAmount
            this.remainingProduct = response.data.remainingProduct
            this.neededProductCount = response.data.neededProductCount
            return false
          }

          this.setSelectdItems.delete(asin)
          this.products = this.products.filter(i => i.asin !== asin)
          this.selectedItems = [...this.setSelectdItems]
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async handleSellItems () {
      const logParams = {
        name: this.isDelete ? eventCode.salemon_agent.product_available.click_disable_notify_list_btn : eventCode.salemon_agent.product_available.click_regis_list_btn,
        properties: {
          asins: this.selectedItems
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      const params = {
        products: this.products.filter(i => this.setSelectdItems.has(i.asin)),
        isDelete: this.isDelete
      }
      await SalemonAgentService.regisProducts(params)
        .then((response) => {
          if (response.data && response.data.suggestPlans && response.data.suggestPlans.length > 0) {
            this.openModalAddListings = true
            this.suggestPlans = response.data.suggestPlans
            this.maxListingAmount = response.data.maxListingAmount
            this.remainingProduct = response.data.remainingProduct
            this.neededProductCount = response.data.neededProductCount
            return false
          }

          this.products = this.products.filter(i => !this.setSelectdItems.has(i.asin))
          this.selectedItems = []
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
          this.closeModalConfirm()
        })
    },
    handleCloseOverProductsModal () {
      $('#over-products-modal').modal('hide')
      this.openModalAddListings = false
    },
    openModalConfirm (isDelete = false) {
      this.isDelete = isDelete
      this.confirmMessage = isDelete ? this.confirmRemoveMessage : this.confirmSellMessage
      this.isShowConfirmModal = true
    },
    closeModalConfirm () {
      $('#confirm-alert').modal('hide')
      this.confirmMessage = ''
      this.isShowConfirmModal = false
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.salemon_agent.product_available.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  watch: {
    selectedItems () {
      this.isCheckAll = this.products.length > 0 && this.selectedItems.length === this.products.length
    }
  }
}
</script>
<style scoped>
.no-wrap {
  flex-wrap: nowrap;
}
.panel-body::before {
  display: unset;
  content: unset;
}
.panel-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.fba-longterm-banner {
  display: flex;
  flex-wrap: nowrap;
  justify-content: left;
  gap: 10px;
  font-size: 20px;
  width: 100%;
  color: #008cc6;
  font-weight: bold;

  .fba-longterm-icon {
    animation: fuwafuwa 3s ease-in-out infinite alternate;
    background: url(https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png) no-repeat center center / 90px auto;
    display: inline-block;
    transition: 1.5s ease-in-out;
    width: 100px;
    height: 100px;
  }

  fieldset {
    border: 3px solid #008cc6;
    border-radius: 12px;
    padding: 10px 20px;
    background: #fff;
    display: inline-block;
    position: relative;

    legend {
      color: #008cc6;
      font-weight: bold;
      border-bottom: unset;
      margin-bottom: unset;
      width: unset;
      padding: 0 10px;
    }

    .fba-longterm-content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .btn-primary {
        align-self: flex-end;
      }
    }
  }
}
.fba-longterm-table {
  overflow: auto;
  max-width: 1800px;
  white-space: nowrap;
  tr {
    border: 1px solid #d9d9d9;
  }
  td, th {
    padding: 5px 10px;
    border: 1px solid #d9d9d9;
  }
  th {
    background-color: #deebf7;
    color: #666;
  }
  .product-info {
    min-width: 60%;
    max-width: 70%;
  }
  td.product-info {
    vertical-align: top;
    .product-name {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
    }
  }
  .fee {
    min-width: 150px;
    text-align: right;
  }
  .actions {
    min-width: 100px;
    text-align: right;
  }
  td.actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .tooltip-wrapper {
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: left;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 12px;
    position: absolute;
    z-index: 1;
    top: 110%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s;
    width: 70%;
  }

  .tooltip-text::after {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #555 transparent;
  }

  .tooltip-wrapper:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }

  .btn-delete-product {
    background-color: #ffffff;
    border: 1px solid #a94442;
    color: #a94442;
    cursor: pointer;
  }

  .btn-delete-product[disabled] {
    cursor: not-allowed;
  }

  .btn-delete-product:not(:disabled):hover {
    color: #ffffff;
    background-color: #a94442;
  }
}

.fba-longterm-table:has(.premium-overlay) {
  position: relative;
  overflow: hidden;
}
@keyframes fuwafuwa {
  0% {
    transform:translate(0, 0) rotate(-7deg);
  }
  50% {
    transform:translate(0, -7px) rotate(0deg);
  }
  100% {
    transform:translate(0, 0) rotate(7deg);
  }
}

@media (max-width: 425px) {
  .text-size-20 {
    font-size: 14px;
  }
  .fba-longterm-icon {
    display: none !important;
  }
  .fba-longterm-content {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/salemonAgent/ProductAvailable.vue